export default __webpack_public_path__ + "static/media/arrow.02164e62.svg";